import { render, staticRenderFns } from "./HeaderText.vue?vue&type=template&id=97250ea0&scoped=true"
import script from "./HeaderText.vue?vue&type=script&lang=js"
export * from "./HeaderText.vue?vue&type=script&lang=js"
import style0 from "./HeaderText.vue?vue&type=style&index=0&id=97250ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97250ea0",
  null
  
)

export default component.exports